// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class BillingPeriodResource extends Resource {
    basePath: string = 'billing/billing-period/';

    objectPath: string = 'billing/billing-period/{ident}/';
}
